import { render, staticRenderFns } from "./courseSelection.vue?vue&type=template&id=4d5c632b&scoped=true"
import script from "./courseSelection.vue?vue&type=script&lang=js"
export * from "./courseSelection.vue?vue&type=script&lang=js"
import style0 from "./courseSelection.vue?vue&type=style&index=0&id=4d5c632b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c632b",
  null
  
)

export default component.exports